import { DpItem } from '@tencent/wphk-components-dp-loader/src/types';

/**
 * 获取优惠券专区首页BI上报扩展字段
 */
export function getHomeBiExt(dpItem: DpItem, businessExt = {}) {
  const { dpId, reportInfo } = dpItem;
  let reportInfoExt  = {};
  if (reportInfo) {
    const { moduleCode, graypolicyId } = reportInfo as any;
    reportInfoExt = {
      // 试验组
      fabtgroup: moduleCode,
      // 试验ID
      fabtlabel: graypolicyId,
      // 试验对象
      report_info: reportInfo,
    };
  }
  return {
    ...businessExt,
    ...reportInfoExt,
    fdp_planno: `${dpId}`,
  };
}
